export enum AdmDependencyEnum {
    Federal = 1,
    State = 2,
    Municipal = 3
}
